module.exports = __webpack_public_path__ + "img/SKMJ_M1.c5ca038c.png";